import { Box, Grid, GridItem } from '@chakra-ui/react';
import { Typography } from '@sgi/gravity';

export const Home = () => {
  return (
    <>
      <Box bg="#FFFFFF" w="100%" p={9}>
        <Grid templateColumns="repeat(3, 1fr)">
          <GridItem colSpan={1}>
            <Typography variant="h1">Welcome!!</Typography>
          </GridItem>
        </Grid>
      </Box>
    </>
  );
};

export default Home;
